var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[(_vm.$route.name == 'rolesCreate')?_c('addHeader',{attrs:{"title":_vm.$t('Create Role'),"description":_vm.$t('From Here You Can Create A New UserRole')}}):_vm._e(),(_vm.$route.name == 'rolesEdit')?_c('addHeader',{attrs:{"title":_vm.$t('Edit Role'),"description":_vm.$t('From Here You Can Modify The Users Roles')}}):_vm._e(),_c('div',{staticClass:"mb-4 row"},[_c('div',{staticClass:"card w-100 h-auto"},[_c('div',{staticClass:"card-header"},[_c('dvider',{staticClass:"dic-role",attrs:{"title":_vm.$t('Basic Information'),"noLine":"true"}})],1),_c('hr'),_c('div',{staticClass:"card-body"},[_c('formInput',{attrs:{"title":_vm.$t('Role Name'),"col":'col-12',"hasErorr":_vm.errors.name,"error":_vm.$t('This field Is required'),"maxlength":"255"},model:{value:(_vm.item.name),callback:function ($$v) {_vm.$set(_vm.item, "name", $$v)},expression:"item.name"}}),_c('formTextarea',{attrs:{"title":_vm.$t('Description of role')},model:{value:(_vm.item.discription),callback:function ($$v) {_vm.$set(_vm.item, "discription", $$v)},expression:"item.discription"}})],1)]),_c('div',{staticClass:"card w-100 h-auto"},[_c('div',{staticClass:"card-header"},[_vm._v(" "+_vm._s(_vm.$t('Options'))+" ")]),_c('hr'),_c('div',{staticClass:"card-body"},[_c('roleGroupInput',{attrs:{"title":_vm.$t('Companies'),"icon":'city',"values":[
                { name: _vm.$t('view'), key: 'companies_show' },
                { name: _vm.$t('Add'), key: 'companies_add' },
                { name: _vm.$t('Edit'), key: 'companies_edit' },
                { name: _vm.$t('Delete'), key: 'companies_delete' }
              ]}}),_c('roleGroupInput',{attrs:{"title":_vm.$t('users'),"icon":'user-chart',"values":[
                { name: _vm.$t('view'), key: 'users_show' },
                { name: _vm.$t('Add'), key: 'users_add' },
                { name: _vm.$t('Edit'), key: 'users_edit' },
                { name: _vm.$t('Delete'), key: 'users_delete' }
              ]}}),_c('roleGroupInput',{attrs:{"title":_vm.$t('roles'),"icon":'users-class',"values":[
                { name: _vm.$t('view'), key: 'roles_show' },
                { name: _vm.$t('Add'), key: 'roles_add' },
                { name: _vm.$t('Edit'), key: 'roles_edit' },
                { name: _vm.$t('Delete'), key: 'roles_delete' }
              ]}})],1)]),_c('hr'),_c('div',{staticClass:"card w-100 h-auto"},[_c('div',{staticClass:"card-header"},[_vm._v(_vm._s(_vm.$t('Sales')))]),_c('hr'),_c('div',{staticClass:"card-body"},[(_vm.$site.customers_allow)?_c('roleGroupInput',{attrs:{"title":_vm.$t('customers'),"icon":'user-alt',"values":[
                { name: _vm.$t('view'), key: 'customers_show' },
                { name: _vm.$t('Add'), key: 'customers_add' },
                { name: _vm.$t('Edit'), key: 'customers_edit' },
                { name: _vm.$t('Delete'), key: 'customers_delete' }
              ]}}):_vm._e(),_c('hr'),(_vm.$site.quotations_allow)?_c('roleGroupInput',{attrs:{"title":_vm.$t('estimates'),"icon":'calculator',"values":[
                { name: _vm.$t('view'), key: 'quotations_show' },
                {
                  name: _vm.$t('Selected Width'),
                  key: 'quotations_show_allow'
                },
                { name: _vm.$t('Add'), key: 'quotations_add' },
                {
                  name: _vm.$t('change Product'),
                  key: 'quotations_edit_product_show'
                },
                { name: _vm.$t('Edit'), key: 'quotations_edit' },
                { name: _vm.$t('Delete'), key: 'quotations_delete' },
                {
                  name: _vm.$t('Transfer To Invoice'),
                  key: 'quotations_turn_into_invoice_show'
                }
              ]}}):_vm._e(),(_vm.$site.quotations_allow)?_c('hr',{staticClass:"col-12"}):_vm._e(),(_vm.$site.quotations_allow)?_c('div',{staticClass:"form-group col-md-6 row"},[_c('label',{staticClass:"col-md-4"},[_vm._v(_vm._s(_vm.$t('Available Cases')))]),_c('div',{staticClass:"col-md-7"},[_c('multiselect',{attrs:{"options":[
                    { name: _vm.$t('Draft'), id: 0 },
                    { name: _vm.$t('Approved'), id: 1 }
                  ],"multiple":true,"close-on-select":false,"clear-on-select":false,"preserve-search":true,"placeholder":_vm.$t('Cases Available For Order'),"label":"name","track-by":"id","hide-selected":true},model:{value:(_vm.item.quotations_allow_status),callback:function ($$v) {_vm.$set(_vm.item, "quotations_allow_status", $$v)},expression:"item.quotations_allow_status"}})],1)]):_vm._e(),(_vm.$site.quotations_allow)?_c('div',{staticClass:"form-group col-md-6 row"},[_c('label',{staticClass:"col-md-4"},[_vm._v(_vm._s(_vm.$t('The Cases Shown')))]),_c('div',{staticClass:"col-md-7"},[_c('multiselect',{attrs:{"options":[
                    { name: _vm.$t('Draft'), id: 0 },
                    { name: _vm.$t('Approved'), id: 1 }
                  ],"multiple":true,"close-on-select":false,"clear-on-select":false,"preserve-search":true,"placeholder":_vm.$t('Cases Presented To Order'),"label":"name","track-by":"id","hide-selected":true},model:{value:(_vm.item.quotations_show_status),callback:function ($$v) {_vm.$set(_vm.item, "quotations_show_status", $$v)},expression:"item.quotations_show_status"}})],1)]):_vm._e(),(_vm.$site.quotations_allow)?_c('hr',{staticClass:"col-12"}):_vm._e(),(_vm.$site.invoices_allow)?_c('roleGroupInput',{attrs:{"title":_vm.$t('invoices'),"icon":'file-invoice-dollar',"values":[
                { name: _vm.$t('view'), key: 'invoices_show' },
                { name: _vm.$t('Add'), key: 'invoices_add' },
                {
                  name: _vm.$t('Selected width'),
                  key: 'invoices_show_allow'
                },
                { name: _vm.$t('Edit'), key: 'invoices_edit' },
                {
                  name: _vm.$t('change Product'),
                  key: 'invoices_edit_product'
                },
                { name: _vm.$t('Delete'), key: 'invoices_delete' },
                {
                  name: _vm.$t('shortSale'),
                  key: 'invoices_short_sale'
                }
              ]}}):_vm._e(),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('Sale Returns'),"icon":'exchange',"values":[
                { name: _vm.$t('view'), key: 'sale_returns_show' },
                { name: _vm.$t('Add'), key: 'sale_returns_add' },
                {
                  name: _vm.$t('Selected Width'),
                  key: 'sale_returns_show_allow'
                },
                { name: _vm.$t('Edit'), key: 'sale_returns_edit' },
                {
                  name: _vm.$t('change Product'),
                  key: 'sale_returns_edit_product'
                },
                { name: _vm.$t('Delete'), key: 'sale_returns_delete' },
                {
                  name: _vm.$t('shortSale'),
                  key: 'sale_returns_short_sale'
                }
              ]}}),(_vm.$site.quotations_allow)?_c('hr',{staticClass:"col-12"}):_vm._e(),(_vm.$site.orders_allow)?_c('roleGroupInput',{attrs:{"title":_vm.$t('saleOrders'),"icon":'briefcase',"values":[
                { name: _vm.$t('view'), key: 'orders_show' },
                { name: _vm.$t('Add'), key: 'orders_add' },
                {
                  name: _vm.$t('Selected Width'),
                  key: 'orders_show_allow'
                },
                { name: _vm.$t('editDate'), key: 'orders_edit_date' },
                {
                  name: _vm.$t('change Product'),
                  key: 'orders_edit_product'
                },
                { name: _vm.$t('Edit'), key: 'orders_edit' },
                { name: _vm.$t('Delete'), key: 'orders_delete' },
                {
                  name: _vm.$t('Transfer To Invoice'),
                  key: 'orders_delete'
                }
              ]}}):_vm._e(),_c('hr',{staticClass:"col-12"})],1)]),_c('div',{staticClass:"card w-100 h-auto"},[_c('div',{staticClass:"card-header"},[_vm._v(_vm._s(_vm.$t('Purchases')))]),_c('hr'),_c('div',{staticClass:"card-body"},[(_vm.$site.suppliers_allow)?_c('roleGroupInput',{attrs:{"title":_vm.$t('Suppliers'),"icon":'user-tie',"values":[
                { name: _vm.$t('view'), key: 'suppliers_show' },
                { name: _vm.$t('Add'), key: 'suppliers_add' },
                { name: _vm.$t('Edit'), key: 'suppliers_edit' },
                { name: _vm.$t('Delete'), key: 'suppliers_delete' }
              ]}}):_vm._e(),_c('hr',{staticClass:"col-12"}),(_vm.$site.bills_allow)?_c('roleGroupInput',{attrs:{"title":_vm.$t('Purchase Bills'),"icon":'receipt',"values":[
                { name: _vm.$t('view'), key: 'bills_show' },
                { name: _vm.$t('Add'), key: 'bills_add' },
                {
                  name: _vm.$t('Selected Width'),
                  key: 'bills_show_allow'
                },
                {
                  name: _vm.$t('change Product'),
                  key: 'bills_edit_product'
                },
                { name: _vm.$t('Edit'), key: 'bills_edit' },
                {
                  name: _vm.$t('Delete'),
                  key: 'bills_delete'
                }
              ]}}):_vm._e(),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('Purchase Returns'),"icon":'exchange',"values":[
                { name: _vm.$t('view'), key: 'purchase_returns_show' },
                { name: _vm.$t('Add'), key: 'purchase_returns_add' },
                {
                  name: _vm.$t('Selected Width'),
                  key: 'purchase_returns_show_allow'
                },
                { name: _vm.$t('Edit'), key: 'purchase_returns_edit' },
                {
                  name: _vm.$t('change Product'),
                  key: 'purchase_returns_edit_product'
                },
                {
                  name: _vm.$t('Delete'),
                  key: 'purchase_returns_delete'
                },
                {
                  name: _vm.$t('shortSale'),
                  key: 'purchase_returns_short_sale'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('purchase Orders'),"icon":'briefcase',"values":[
                { name: _vm.$t('view'), key: 'purchase_orders_show' },
                { name: _vm.$t('Add'), key: 'purchase_orders_add' },
                {
                  name: _vm.$t('Selected Width'),
                  key: 'purchase_orders_show_allow'
                },
                {
                  name: _vm.$t('change Product'),
                  key: 'purchase_orders_edit_product'
                },
                { name: _vm.$t('Edit'), key: 'purchase_orders_edit' },
                {
                  name: _vm.$t('Delete'),
                  key: 'purchase_orders_delete'
                }
              ]}})],1)]),_c('div',{staticClass:"card w-100 h-auto"},[_c('div',{staticClass:"card-header"},[_vm._v(_vm._s(_vm.$t('Safes')))]),_c('hr'),_c('div',{staticClass:"card-body"},[_c('roleGroupInput',{attrs:{"title":_vm.$t('safes'),"icon":'treasure-chest',"values":[
                { name: _vm.$t('view'), key: 'safes_show' },
                { name: _vm.$t('Add'), key: 'safes_add' },
                {
                  name: _vm.$t('Selected Width'),
                  key: 'safes_show_allow'
                },
                { name: _vm.$t('Edit'), key: 'safes_edit' },
                { name: _vm.$t('Delete'), key: 'safes_delete' }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('bank Accounts'),"icon":'university',"values":[
                { name: _vm.$t('view'), key: 'bank_accounts_show' },
                { name: _vm.$t('Add'), key: 'bank_accounts_add' },
                {
                  name: _vm.$t('Selected Width'),
                  key: 'bank_accounts_show_allow'
                },
                { name: _vm.$t('Edit'), key: 'bank_accounts_edit' },
                {
                  name: _vm.$t('Delete'),
                  key: 'bank_accounts_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('sale Payments'),"icon":'credit-card-front',"values":[
                { name: _vm.$t('view'), key: 'sales_payments_show' },
                { name: _vm.$t('Add'), key: 'sales_payments_add' },
                {
                  name: _vm.$t('Selected width'),
                  key: 'sales_payments_show_allow'
                },
                {
                  name: _vm.$t('Change Options'),
                  key: 'sales_payments_edit_item'
                },
                { name: _vm.$t('Edit'), key: 'sales_payments_edit' },
                {
                  name: _vm.$t('Delete'),
                  key: 'sales_payments_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('purchase Payments'),"icon":'credit-card-front',"values":[
                {
                  name: _vm.$t('view'),
                  key: 'purchase_payments_show'
                },
                { name: _vm.$t('Add'), key: 'purchase_payments_add' },
                {
                  name: _vm.$t('Selected width'),
                  key: 'purchase_payments_show_allow'
                },
                {
                  name: _vm.$t('Change options'),
                  key: 'purchase_payments_edit_item'
                },
                {
                  name: _vm.$t('Edit'),
                  key: 'purchase_payments_edit'
                },
                {
                  name: _vm.$t('Delete'),
                  key: 'purchase_payments_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('expenses'),"icon":'usd-square',"values":[
                { name: _vm.$t('view'), key: 'expenses_show' },
                { name: _vm.$t('Add'), key: 'expenses_add' },
                {
                  name: _vm.$t('Selected width'),
                  key: 'expenses_show_allow'
                },
                { name: _vm.$t('Edit'), key: 'expenses_edit' },
                { name: _vm.$t('Delete'), key: 'expenses_delete' }
              ]}}),_c('hr',{staticClass:"col-12"}),(_vm.$site.safes_allow)?_c('roleGroupInput',{attrs:{"title":_vm.$t('safes'),"icon":'treasure-chest',"values":[
                { name: _vm.$t('view'), key: 'safes_show' },
                { name: _vm.$t('Add'), key: 'safes_add' },
                {
                  name: _vm.$t('Selected width'),
                  key: 'safes_show_allow'
                },
                { name: _vm.$t('Edit'), key: 'safes_edit' },
                { name: _vm.$t('Delete'), key: 'safes_delete' }
              ]}}):_vm._e(),(_vm.$site.safes_allow)?_c('hr',{staticClass:"col-12"}):_vm._e(),_c('roleGroupInput',{attrs:{"title":_vm.$t('deposit Lockers'),"icon":'envelope-open-dollar',"values":[
                { name: _vm.$t('view'), key: 'safes_deposits_show' },
                { name: _vm.$t('Add'), key: 'safes_deposits_add' },
                {
                  name: _vm.$t('Selected Width'),
                  key: 'safes_deposits_show_allow'
                },
                {
                  name: _vm.$t('Change Options'),
                  key: 'safes_deposits_edit_item'
                },
                { name: _vm.$t('Edit'), key: 'safes_deposits_edit' },
                {
                  name: _vm.$t('Delete'),
                  key: 'safes_deposits_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('pull Out Lockers'),"icon":'envelope-open-dollar',"values":[
                {
                  name: _vm.$t('view'),
                  key: 'safes_withdrawals_show'
                },
                { name: _vm.$t('Add'), key: 'safes_withdrawals_add' },
                {
                  name: _vm.$t('Selected Width'),
                  key: 'safes_withdrawals_show_allow'
                },
                {
                  name: _vm.$t('Change Options'),
                  key: 'safes_withdrawals_edit_item'
                },
                {
                  name: _vm.$t('Edit'),
                  key: 'safes_withdrawals_edit'
                },
                {
                  name: _vm.$t('Delete'),
                  key: 'safes_withdrawals_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('Moving Lockers'),"icon":'envelope-open-dollar',"values":[
                { name: _vm.$t('view'), key: 'safes_transfers_show' },
                { name: _vm.$t('Add'), key: 'safes_transfers_add' },
                {
                  name: _vm.$t('Selected width'),
                  key: 'safes_transfers_show_allow'
                },
                {
                  name: _vm.$t('Change Options'),
                  key: 'safes_transfers_edit_item'
                },
                { name: _vm.$t('Edit'), key: 'safes_transfers_edit' },
                {
                  name: _vm.$t('Delete'),
                  key: 'safes_transfers_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('Tax payment'),"icon":'usd-square',"values":[
                { name: _vm.$t('view'), key: 'tax_payments_show' },
                { name: _vm.$t('Add'), key: 'tax_payments_add' },

                { name: _vm.$t('Edit'), key: 'tax_payments_edit' },
                { name: _vm.$t('Delete'), key: 'tax_payments_delete' }
              ]}}),_c('hr',{staticClass:"col-12"})],1)]),_c('div',{staticClass:"card w-100 h-auto"},[_c('div',{staticClass:"card-header"},[_vm._v(_vm._s(_vm.$t('Stores')))]),_c('hr'),_c('div',{staticClass:"card-body"},[_c('roleGroupInput',{attrs:{"title":_vm.$t('stores'),"icon":'store-alt',"values":[
                { name: _vm.$t('view'), key: 'stores_show' },
                {
                  name: _vm.$t('Selected Width'),
                  key: 'stores_show_allow'
                },
                { name: _vm.$t('Add'), key: 'stores_add' },
                { name: _vm.$t('Edit'), key: 'stores_edit' },
                {
                  name: _vm.$t('Products Transportation'),
                  key: 'stores_move_products'
                },
                {
                  name: _vm.$t('add Products'),
                  key: 'stores_add_products'
                },
                {
                  name: _vm.$t('withdraw Products'),
                  key: 'stores_remove_products'
                },
                { name: _vm.$t('Delete'), key: 'stores_delete' }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('products'),"icon":'inventory',"values":[
                { name: _vm.$t('view'), key: 'products_show' },
                { name: _vm.$t('Add'), key: 'products_add' },
                { name: _vm.$t('Edit'), key: 'products_edit' },
                { name: _vm.$t('Cost'), key: 'products_cost' },
                { name: _vm.$t('Delete'), key: 'products_delete' }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('Warehouse Deposit'),"icon":'boxes-alt',"values":[
                { name: _vm.$t('view'), key: 'stores_deposits_show' },
                { name: _vm.$t('Add'), key: 'stores_deposits_add' },
                {
                  name: _vm.$t('Selected width'),
                  key: 'stores_deposits_show_allow'
                },
                {
                  name: _vm.$t('Change options'),
                  key: 'stores_deposits_edit_item'
                },
                { name: _vm.$t('Edit'), key: 'stores_deposits_edit' },
                {
                  name: _vm.$t('Delete'),
                  key: 'stores_deposits_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('Store Withdrawals'),"icon":'boxes-alt',"values":[
                {
                  name: _vm.$t('view'),
                  key: 'stores_withdrawals_show'
                },
                { name: _vm.$t('Add'), key: 'stores_withdrawals_add' },
                {
                  name: _vm.$t('Selected Width'),
                  key: 'stores_withdrawals_show_allow'
                },
                {
                  name: _vm.$t('Change Options'),
                  key: 'stores_withdrawals_edit_item'
                },
                {
                  name: _vm.$t('Edit'),
                  key: 'stores_withdrawals_edit'
                },
                {
                  name: _vm.$t('Delete'),
                  key: 'stores_withdrawals_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('Warehouse Transfer'),"icon":'boxes-alt',"values":[
                { name: _vm.$t('view'), key: 'stores_transfers_show' },
                { name: _vm.$t('Add'), key: 'stores_transfers_add' },
                {
                  name: _vm.$t('Selected Width'),
                  key: 'stores_transfers_show_allow'
                },
                {
                  name: _vm.$t('Change Options'),
                  key: 'stores_transfers_edit_item'
                },
                { name: _vm.$t('Edit'), key: 'stores_transfers_edit' },
                {
                  name: _vm.$t('Delete'),
                  key: 'stores_transfers_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('Stores Loading'),"icon":'boxes-alt',"values":[
                { name: _vm.$t('view'), key: 'stores_orders_show' },
                { name: _vm.$t('Add'), key: 'stores_orders_add' },
                {
                  name: _vm.$t('Selected Width'),
                  key: 'stores_orders_show_allow'
                },
                {
                  name: _vm.$t('Change Options'),
                  key: 'stores_orders_edit_item'
                },
                { name: _vm.$t('Edit'), key: 'stores_orders_edit' },
                {
                  name: _vm.$t('Delete'),
                  key: 'stores_orders_delete'
                }
              ]}})],1)]),_c('div',{staticClass:"card w-100 h-auto"},[_c('div',{staticClass:"card-header"},[_vm._v(_vm._s(_vm.$t('Employees')))]),_c('hr'),_c('div',{staticClass:"card-body"},[_c('roleGroupInput',{attrs:{"title":_vm.$t('employees'),"icon":'user-cog',"values":[
                { name: _vm.$t('view'), key: 'employees_show' },
                { name: _vm.$t('Add'), key: 'employees_add' },
                { name: _vm.$t('Edit'), key: 'employees_edit' },
                { name: _vm.$t('Delete'), key: 'employees_delete' }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('Employee Salaries'),"icon":'user-chart',"values":[
                {
                  name: _vm.$t('view'),
                  key: 'employees_salaries_show'
                },
                { name: _vm.$t('Add'), key: 'employees_salaries_add' },
                {
                  name: _vm.$t('Selected Width'),
                  key: 'employees_salaries_show_allow'
                },
                {
                  name: _vm.$t('Change Options'),
                  key: 'employees_salaries_edit_item'
                },
                {
                  name: _vm.$t('Edit'),
                  key: 'employees_salaries_edit'
                },
                {
                  name: _vm.$t('Delete'),
                  key: 'employees_salaries_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('employee Incentives'),"icon":'user-chart',"values":[
                {
                  name: _vm.$t('view'),
                  key: 'employees_incentives_show'
                },
                {
                  name: _vm.$t('Add'),
                  key: 'employees_incentives_add'
                },
                {
                  name: _vm.$t('Selected Width'),
                  key: 'employees_incentives_show_allow'
                },
                {
                  name: _vm.$t('Change Options'),
                  key: 'employees_incentives_edit_item'
                },
                {
                  name: _vm.$t('Edit'),
                  key: 'employees_incentives_edit'
                },
                {
                  name: _vm.$t('Delete'),
                  key: 'employees_incentives_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('employee Discounts'),"icon":'user-chart',"values":[
                {
                  name: _vm.$t('view'),
                  key: 'employees_deductions_show'
                },
                {
                  name: _vm.$t('Add'),
                  key: 'employees_deductions_add'
                },
                {
                  name: _vm.$t('Selected Width'),
                  key: 'employees_deductions_show_allow'
                },
                {
                  name: _vm.$t('Change Options'),
                  key: 'employees_deductions_edit_item'
                },
                {
                  name: _vm.$t('Edit'),
                  key: 'employees_deductions_edit'
                },
                {
                  name: _vm.$t('Delete'),
                  key: 'employees_deductions_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('staff Draws'),"icon":'user-chart',"values":[
                {
                  name: _vm.$t('view'),
                  key: 'employees_withdrawals_show'
                },
                {
                  name: _vm.$t('Add'),
                  key: 'employees_withdrawals_add'
                },
                {
                  name: _vm.$t('Selected Width'),
                  key: 'employees_withdrawals_show_allow'
                },
                {
                  name: _vm.$t('Change Options'),
                  key: 'employees_withdrawals_edit_item'
                },
                {
                  name: _vm.$t('Edit'),
                  key: 'employees_withdrawals_edit'
                },
                {
                  name: _vm.$t('Delete'),
                  key: 'employees_withdrawals_delete'
                }
              ]}})],1)]),_c('div',{staticClass:"card w-100 h-auto"},[_c('div',{staticClass:"card-header"},[_vm._v(_vm._s(_vm.$t('Partners')))]),_c('hr'),_c('div',{staticClass:"card-body"},[_c('roleGroupInput',{attrs:{"title":_vm.$t('Partners'),"icon":'handshake',"values":[
                { name: _vm.$t('view'), key: 'partners_show' },
                { name: _vm.$t('Add'), key: 'partners_add' },
                { name: _vm.$t('Edit'), key: 'partners_edit' },
                { name: _vm.$t('Delete'), key: 'partners_delete' }
              ]}}),(_vm.$site.partners_allow)?_c('hr',{staticClass:"col-12"}):_vm._e(),_c('roleGroupInput',{attrs:{"title":_vm.$t('Partners Deposit'),"icon":'handshake',"values":[
                {
                  name: _vm.$t('view'),
                  key: 'partners_deposits_show'
                },
                { name: _vm.$t('Add'), key: 'partners_deposits_add' },
                {
                  name: _vm.$t('Selected width'),
                  key: 'partners_deposits_show_allow'
                },
                {
                  name: _vm.$t('Change options'),
                  key: 'partners_deposits_edit_item'
                },
                {
                  name: _vm.$t('Edit'),
                  key: 'partners_deposits_edit'
                },
                {
                  name: _vm.$t('Delete'),
                  key: 'partners_deposits_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('Withdrawal Of Partners'),"icon":'handshake',"values":[
                {
                  name: _vm.$t('view'),
                  key: 'partners_withdrawals_show'
                },
                {
                  name: _vm.$t('Add'),
                  key: 'partners_withdrawals_add'
                },
                {
                  name: _vm.$t('Selected width'),
                  key: 'partners_withdrawals_show_allow'
                },
                {
                  name: _vm.$t('Change Options'),
                  key: 'partners_withdrawals_edit_item'
                },
                {
                  name: _vm.$t('Edit'),
                  key: 'partners_withdrawals_edit'
                },
                {
                  name: _vm.$t('Delete'),
                  key: 'partners_withdrawals_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('Partners Profits'),"icon":'handshake',"values":[
                { name: _vm.$t('view'), key: 'partners_profits_show' },
                { name: _vm.$t('Add'), key: 'partners_profits_add' },
                {
                  name: _vm.$t('Selected Width'),
                  key: 'partners_profits_show_allow'
                },
                {
                  name: _vm.$t('Change options'),
                  key: 'partners_profits_edit_item'
                },
                { name: _vm.$t('Edit'), key: 'partners_profits_edit' },
                {
                  name: _vm.$t('Delete'),
                  key: 'partners_profits_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('partners Settlements'),"icon":'handshake',"values":[
                {
                  name: _vm.$t('view'),
                  key: 'partners_settlements_show'
                },
                {
                  name: _vm.$t('Add'),
                  key: 'partners_settlements_add'
                },
                {
                  name: _vm.$t('Selected Width'),
                  key: 'partners_settlements_show_allow'
                },
                {
                  name: _vm.$t('Change Options'),
                  key: 'partners_settlements_edit_item'
                },
                {
                  name: _vm.$t('Edit'),
                  key: 'partners_settlements_edit'
                },
                {
                  name: _vm.$t('Delete'),
                  key: 'partners_settlements_delete'
                }
              ]}})],1)]),_c('div',{staticClass:"card w-100 h-auto"},[_c('div',{staticClass:"card-header"},[_vm._v(_vm._s(_vm.$t('Cheques')))]),_c('hr'),_c('div',{staticClass:"card-body"},[_c('roleGroupInput',{attrs:{"title":_vm.$t('Sales cheques'),"icon":'money-check-alt',"values":[
                { name: _vm.$t('view'), key: 'sales_cheques_show' },
                { name: _vm.$t('Add'), key: 'sales_cheques_add' },
                {
                  name: _vm.$t('Selected width'),
                  key: 'sales_cheques_show_allow'
                },
                {
                  name: _vm.$t('Change options'),
                  key: '.sales_cheques_edit_item'
                },
                { name: _vm.$t('Edit'), key: 'sales_cheques_edit' },
                {
                  name: _vm.$t('Delete'),
                  key: 'sales_cheques_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('purchase Cheques'),"icon":'money-check-alt',"values":[
                { name: _vm.$t('view'), key: 'purchase_cheques_show' },
                { name: _vm.$t('Add'), key: 'purchase_cheques_add' },
                {
                  name: _vm.$t('Selected width'),
                  key: 'purchase_cheques_show_allow'
                },
                {
                  name: _vm.$t('Change Options'),
                  key: 'purchase_cheques_edit_item'
                },
                { name: _vm.$t('Edit'), key: 'purchase_cheques_edit' },
                {
                  name: _vm.$t('Delete'),
                  key: 'purchase_cheques_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"})],1)]),_c('div',{staticClass:"card w-100 h-auto"},[_c('div',{staticClass:"card-header"},[_vm._v(_vm._s(_vm.$t('Discounts')))]),_c('hr'),_c('div',{staticClass:"card-body"},[_c('roleGroupInput',{attrs:{"title":_vm.$t('Sales Discounts'),"icon":'badge-percent',"values":[
                { name: _vm.$t('view'), key: 'sales_discounts_show' },
                { name: _vm.$t('Add'), key: 'sales_discounts_add' },
                {
                  name: _vm.$t('Selected width'),
                  key: 'sales_discounts_show_allow'
                },
                {
                  name: _vm.$t('Change options'),
                  key: 'sales_discounts_edit_item'
                },
                { name: _vm.$t('Edit'), key: 'sales_discounts_edit' },
                {
                  name: _vm.$t('Delete'),
                  key: 'sales_discounts_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"}),_c('roleGroupInput',{attrs:{"title":_vm.$t('Purchase discounts'),"icon":'badge-percent',"values":[
                {
                  name: _vm.$t('view'),
                  key: 'purchase_discounts_show'
                },
                { name: _vm.$t('Add'), key: 'purchase_discounts_add' },
                {
                  name: _vm.$t('Selected width'),
                  key: 'purchase_discounts_show_allow'
                },
                {
                  name: _vm.$t('Change options'),
                  key: 'purchase_discounts_edit_item'
                },
                {
                  name: _vm.$t('Edit'),
                  key: 'purchase_discounts_edit'
                },
                {
                  name: _vm.$t('Delete'),
                  key: 'purchase_discounts_delete'
                }
              ]}}),_c('hr',{staticClass:"col-12"})],1)]),_c('div',{staticClass:"card w-100 h-auto"},[_c('div',{staticClass:"card-header"},[_vm._v(_vm._s(_vm.$t('Processes')))]),_c('hr'),_c('div',{staticClass:"card-body"},[_c('roleGroupInput',{attrs:{"title":_vm.$t('capitals'),"icon":'archway',"values":[
                { name: _vm.$t('view'), key: 'capitals_show' },
                { name: _vm.$t('Add'), key: 'capitals_add' },
                { name: _vm.$t('Edit'), key: 'capitals_edit' },
                { name: _vm.$t('Delete'), key: 'capitals_delete' }
              ]}}),_c('hr',{staticClass:"col-12"})],1)]),_c('hr',{staticClass:"mt-5 mb-5 col-12"}),_c('small',{staticClass:"form-text text-muted mb-4 col-12"},[_vm._v(_vm._s(_vm.$t('Information')))]),_c('div',{staticClass:"col-12"},[_c('label',{staticClass:"mb-3"},[_c('div',{staticClass:"custom-control custom-switch"},[_c('label',{staticClass:"bg-check-label",attrs:{"for":"reports_show"}},[_c('i',{staticClass:"far fa-user-chart"}),_vm._v(" "+_vm._s(_vm.$t('reports'))+" : ")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.reports_show),expression:"item.reports_show"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"reports_show","value":"1"},domProps:{"checked":Array.isArray(_vm.item.reports_show)?_vm._i(_vm.item.reports_show,"1")>-1:(_vm.item.reports_show)},on:{"change":function($event){var $$a=_vm.item.reports_show,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.item, "reports_show", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.item, "reports_show", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.item, "reports_show", $$c)}}}}),_c('label',{staticClass:"custom-control-label",attrs:{"for":"reports_show"}})])])]),(_vm.item.reports_show)?_c('div',{staticClass:"col-12"},[_c('label',{staticClass:"mb-3"},[_c('div',{staticClass:"custom-control custom-switch"},[_c('label',{staticClass:"bg-check-label",attrs:{"for":"reports_show"}},[_c('i',{staticClass:"far fa-user-chart"}),_vm._v(" "+_vm._s(_vm.$t('Show Selected Reports'))+" : ")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.reports_show_allow),expression:"item.reports_show_allow"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"reports_show_allow","value":"1"},domProps:{"checked":Array.isArray(_vm.item.reports_show_allow)?_vm._i(_vm.item.reports_show_allow,"1")>-1:(_vm.item.reports_show_allow)},on:{"change":function($event){var $$a=_vm.item.reports_show_allow,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.item, "reports_show_allow", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.item, "reports_show_allow", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.item, "reports_show_allow", $$c)}}}}),_c('label',{staticClass:"custom-control-label",attrs:{"for":"reports_show_allow"}})])])]):_vm._e(),(_vm.item.reports_show)?_c('div',{staticClass:"col-12"},[_c('label',{staticClass:"mb-3"},[_c('div',{staticClass:"custom-control custom-switch"},[_c('label',{staticClass:"bg-check-label",attrs:{"for":"reports_earning_show"}},[_c('i',{staticClass:"far fa-user-chart"}),_vm._v(" "+_vm._s(_vm.$t('View Earnings In Reports'))+" : ")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.reports_earning_show),expression:"item.reports_earning_show"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"reports_earning_show","value":"1"},domProps:{"checked":Array.isArray(_vm.item.reports_earning_show)?_vm._i(_vm.item.reports_earning_show,"1")>-1:(_vm.item.reports_earning_show)},on:{"change":function($event){var $$a=_vm.item.reports_earning_show,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.item, "reports_earning_show", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.item, "reports_earning_show", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.item, "reports_earning_show", $$c)}}}}),_c('label',{staticClass:"custom-control-label",attrs:{"for":"reports_earning_show"}})])])]):_vm._e(),_c('div',{staticClass:"col-12"},[_c('label',{staticClass:"mb-3"},[_c('div',{staticClass:"custom-control custom-switch"},[_c('label',{staticClass:"bg-check-label",attrs:{"for":"accounting_show"}},[_c('i',{staticClass:"far fa-balance-scale"}),_vm._v(" "+_vm._s(_vm.$t('Accounting'))+" : ")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.accounting_show),expression:"item.accounting_show"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"accounting_show","value":"1"},domProps:{"checked":Array.isArray(_vm.item.accounting_show)?_vm._i(_vm.item.accounting_show,"1")>-1:(_vm.item.accounting_show)},on:{"change":function($event){var $$a=_vm.item.accounting_show,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.item, "accounting_show", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.item, "accounting_show", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.item, "accounting_show", $$c)}}}}),_c('label',{staticClass:"custom-control-label",attrs:{"for":"accounting_show"}})])])]),_c('div',{staticClass:"col-12"},[_c('label',{staticClass:"mb-3"},[_c('div',{staticClass:"custom-control custom-switch"},[_c('label',{staticClass:"bg-check-label",attrs:{"for":"options_show"}},[_c('i',{staticClass:"far fa-cog"}),_vm._v(" "+_vm._s(_vm.$t('Settings'))+": ")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.options_show),expression:"item.options_show"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"options_show","value":"1"},domProps:{"checked":Array.isArray(_vm.item.options_show)?_vm._i(_vm.item.options_show,"1")>-1:(_vm.item.options_show)},on:{"change":function($event){var $$a=_vm.item.options_show,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.item, "options_show", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.item, "options_show", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.item, "options_show", $$c)}}}}),_c('label',{staticClass:"custom-control-label",attrs:{"for":"options_show"}})])])]),_c('div',{staticClass:"col-12"},[_c('label',{staticClass:"mb-3"},[_c('div',{staticClass:"custom-control custom-switch"},[_c('label',{staticClass:"bg-check-label",attrs:{"for":"profile_edit"}},[_c('i',{staticClass:"far fa-cog"}),_vm._v(_vm._s(_vm.$t('User Settings'))+": ")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.profile_edit),expression:"item.profile_edit"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"profile_edit","value":"1"},domProps:{"checked":Array.isArray(_vm.item.profile_edit)?_vm._i(_vm.item.profile_edit,"1")>-1:(_vm.item.profile_edit)},on:{"change":function($event){var $$a=_vm.item.profile_edit,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.item, "profile_edit", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.item, "profile_edit", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.item, "profile_edit", $$c)}}}}),_c('label',{staticClass:"custom-control-label",attrs:{"for":"profile_edit"}})])])]),_c('div',{staticClass:"col-12"},[_c('label',{staticClass:"mb-3"},[_c('div',{staticClass:"custom-control custom-switch"},[_c('label',{staticClass:"bg-check-label",attrs:{"for":"buckup_allow"}},[_c('i',{staticClass:"far fa-database"}),_vm._v(" "+_vm._s(_vm.$t('backup Allow'))+" : ")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.item.buckup_allow),expression:"item.buckup_allow"}],staticClass:"custom-control-input",attrs:{"type":"checkbox","id":"buckup_allow","value":"1"},domProps:{"checked":Array.isArray(_vm.item.buckup_allow)?_vm._i(_vm.item.buckup_allow,"1")>-1:(_vm.item.buckup_allow)},on:{"change":function($event){var $$a=_vm.item.buckup_allow,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.item, "buckup_allow", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.item, "buckup_allow", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.item, "buckup_allow", $$c)}}}}),_c('label',{staticClass:"custom-control-label",attrs:{"for":"buckup_allow"}})])])]),(_vm.item.reports_show)?_c('div',{staticClass:"form-group col-md-6 row"},[_c('label',{staticClass:"col-md-4"},[_vm._v(_vm._s(_vm.$t('Front Reports')))]),_c('div',{staticClass:"col-md-7"},[_c('multiselect',{attrs:{"options":_vm.reports,"multiple":true,"close-on-select":false,"clear-on-select":false,"preserve-search":true,"placeholder":_vm.$t('Choose The Required Reports In The Interface'),"label":"name","track-by":"link","hide-selected":true},model:{value:(_vm.item.main_reports),callback:function ($$v) {_vm.$set(_vm.item, "main_reports", $$v)},expression:"item.main_reports"}})],1)]):_vm._e(),(_vm.item.reports_show)?_c('div',{staticClass:"form-group col-md-6 row"},[_c('label',{staticClass:"col-md-4"},[_vm._v(_vm._s(_vm.$t('Available Reports')))]),_c('div',{staticClass:"col-md-7"},[_c('multiselect',{attrs:{"options":_vm.allowReports,"multiple":true,"close-on-select":false,"clear-on-select":false,"preserve-search":true,"placeholder":_vm.$t('Choose The Available Reports'),"label":"name","track-by":"id","hide-selected":true},model:{value:(_vm.item.available_reports),callback:function ($$v) {_vm.$set(_vm.item, "available_reports", $$v)},expression:"item.available_reports"}})],1)]):_vm._e(),_c('div',{staticClass:"form-group col-md-6 row"},[_c('label',{staticClass:"col-md-4"},[_vm._v(_vm._s(_vm.$t('Exhibits In The Facade')))]),_c('div',{staticClass:"col-md-7"},[_c('multiselect',{attrs:{"options":_vm.elements,"multiple":true,"close-on-select":false,"clear-on-select":false,"preserve-search":true,"placeholder":_vm.$t('Choose Displays In The Interface'),"label":"name","track-by":"id","hide-selected":true},model:{value:(_vm.item.main_elements),callback:function ($$v) {_vm.$set(_vm.item, "main_elements", $$v)},expression:"item.main_elements"}})],1)]),_c('div',{staticClass:"form-group col-md-6 row"},[_c('label',{staticClass:"col-md-4"},[_vm._v(_vm._s(_vm.$t('Main actions')))]),_c('div',{staticClass:"col-md-7"},[_c('multiselect',{attrs:{"options":_vm.actions,"multiple":true,"close-on-select":false,"clear-on-select":false,"preserve-search":true,"placeholder":_vm.$t('Choose Actions In The Interface'),"label":"name","track-by":"link","hide-selected":true},model:{value:(_vm.item.main_actions),callback:function ($$v) {_vm.$set(_vm.item, "main_actions", $$v)},expression:"item.main_actions"}})],1)]),_c('hr',{staticClass:"mt-5 mb-5 col-12"}),(_vm.$route.name == 'rolesCreate' && !_vm.$parent.stopEdit)?_c('a',{staticClass:"btn btn-block btn-primary",on:{"click":function($event){return _vm.saveItem()}}},[_vm._v(" "+_vm._s(_vm.$t('Create Role'))+" ")]):_vm._e(),(_vm.$route.name == 'rolesEdit' && !_vm.$parent.stopEdit)?_c('a',{staticClass:"btn btn-block btn-primary",on:{"click":function($event){return _vm.saveItem()}}},[_vm._v(" "+_vm._s(_vm.$t('Edit role'))+" ")]):_vm._e(),(_vm.$parent.stopEdit)?_c('loading'):_vm._e()],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }